import LeaderboardMetricFieldName from "@mapmycustomers/shared/enum/fieldModel/LeaderboardMetricFieldName";

const NEGATIVE_METRICS = [
  LeaderboardMetricFieldName.DEALS_CLOSED_LOST,
  LeaderboardMetricFieldName.REVENUE_CLOSED_LOST,
  LeaderboardMetricFieldName.DEALS_ROTTING,
];

const isNegativeMetric = (metric: LeaderboardMetricFieldName): boolean =>
  NEGATIVE_METRICS.includes(metric);

export default isNegativeMetric;
